<template>

    <v-modal
        :open="open"
        class="c-modal_remove_event">
        <h2>Usuń zaplanowane wydarzenie</h2>
        <p class="c-modal_remove_event__question">Czy na pewno chcesz usunąć zaplanowane wydarzenie?</p>
        <form-row v-if="portalVisit">
            <form-switch
                v-model="releaseSlot"
                label="Zwolnij slot czasowy w portalu"
                true-value="1"
                false-value="0">
            </form-switch>
        </form-row>

        <v-btn
            type="red-white"
            @click="cancel">
            Anuluj
        </v-btn>
        <v-btn
            type="red"
            @click="ok"
            has-loader
            :loading="isLoading">
            Tak, usuń
        </v-btn>
    </v-modal>

</template>


<script>

import {FormSwitch, FormRow} from 'Components/Form'
import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'EventRemoveModal',

    data() {
        return {
            releaseSlot: '1',
            eventId: null,
            portalVisit: false,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
        },

        ok() {
            this.isLoading = true
            this.$store.dispatch('EVENT_DELETE', {
                id: this.eventId,
                query: {
                    release_the_slot_in_the_portal: this.releaseSlot
                }
            }).then(({data}) => {
                this.isLoading = false
                this.$alert.success('Usuwanie zaplanowanego wydarzenia', data.message)
                this.open = false
                this.$emit('success', this.eventId)
            }).catch((error) => {
                this.isLoading = false
                this.$alert.error('Usuwanie zaplanowanego wydarzenia', error.response.data.message)
                this.open = false
                this.$emit('failure')
            })
        },
    },

    mounted() {
        this.$on('open', (id, portalVisit = false) => {
            this.eventId = id
            this.portalVisit = portalVisit;
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn,
        FormSwitch,
        FormRow
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_remove_event {
    text-align: center;

    &__question {
        margin: 1.5rem 0;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
